import { AccessType } from '../enums/access-type.enum';
import { DataServices } from '../enums/data-services.enum';
import { AccessServiceActions } from '../enums/service-actions/access-service-actions.enum';
import { InvestigatorServiceActions } from '../enums/service-actions/investigator-service-actions.enum';
import { OrganizationServiceActions } from '../enums/service-actions/organization-service-actions.enum';
import { ApiKeysServiceActions } from '../enums/service-actions/api-keys-service-actions.enum';
import { PoliciesServiceActions } from '../enums/service-actions/policies-service-actions.enum';

export enum FeatureName {
  UMUserWrite = 'um-user-write',
  UMUsersRead = 'um-user-read',
  UMRolesRead = 'um-roles-read',
  UMRolesWrite = 'um-roles-write',
  UMSendInvites = 'um-send-invites',
  UMAcceptInvites = 'um-accept-invites',
  UMResetPassword = 'um-reset-password',

  OverallLayoutWrite = 'overall-layout-write',
  OverallQueriesWrite = 'overall-queries-write',
  OverallColumns = 'overall-columns',
  OverallExport = 'overall-export',

  OverallLinksRead = 'overall-links-read',
  OverallLinksWrite = 'overall-links-write',
  OverallAliasesRead = 'overall-aliases-read',
  OverallAliasesWrite = 'overall-aliases-write',

  OverallRiskRead = 'overall-risk-read',

  OverallUniqueUsers = 'overall-unique-users',

  OrganizationWrite = 'org-write',
  ApiKeysRead = 'api-keys-read',
  ApiKeysWrite = 'api-keys-write',

  PolicyTriggersWrite = 'policy-triggers-write',
  PolicyTriggersRead = 'policy-triggers-read',
  PoliciesWrite = 'policies-write',
  PoliciesSignalsRead = 'policies-signals-read',
  PoliciesSignalsWrite = 'policies-signals-write',

  PolicyListWrite = 'policy-list-write',

  PolicyVariableWrite = 'policy-variable-write',
  PolicyVariableRead = 'policy-variable-read',

  PolicyImport = 'policy-import',
  PolicyExport = 'policy-export',

  OrganizationSwitch = 'organization-switch',

  OtpInitData = 'otp-init-data',
}

export const featurePermissions = new Map([
  // User Management
  [
    FeatureName.UMUsersRead,
    [
      `${DataServices.Access}.${AccessServiceActions.Users}.${AccessType.Read}`,
    ],
  ],
  [
    FeatureName.UMUserWrite,
    [
      `${DataServices.Access}.${AccessServiceActions.Users}.${AccessType.Write}`,
    ],
  ],
  [
    FeatureName.UMRolesRead,
    [
      `${DataServices.Access}.${AccessServiceActions.Roles}.${AccessType.Read}`,
    ],
  ],
  [
    FeatureName.UMRolesWrite,
    [
      `${DataServices.Access}.${AccessServiceActions.Roles}.${AccessType.Write}`,
    ],
  ],
  [
    FeatureName.UMSendInvites,
    [
      `${DataServices.Access}.${AccessServiceActions.Invites}.${AccessType.Write}`,
    ],
  ],
  [
    FeatureName.UMAcceptInvites,
    [
      `${DataServices.Access}.${AccessServiceActions.Invites}.${AccessType.Read}`,
    ],
  ],
  [
    FeatureName.UMResetPassword,
    [
      `${DataServices.Access}.${AccessServiceActions.Password}.${AccessType.Write}`,
    ],
  ],
  // Overall
  [
    FeatureName.OverallExport,
    [
      `${DataServices.Investigator}.${InvestigatorServiceActions.Export}.${AccessType.Read}`,
    ],
  ],
  [
    FeatureName.OverallLinksRead,
    [
      `${DataServices.Investigator}.${InvestigatorServiceActions.ColumnLinks}.${AccessType.Read}`,
    ],
  ],
  [
    FeatureName.OverallAliasesRead,
    [
      `${DataServices.Investigator}.${InvestigatorServiceActions.Aliases}.${AccessType.Read}`,
    ],
  ],
  [
    FeatureName.OverallLinksWrite,
    [
      `${DataServices.Investigator}.${InvestigatorServiceActions.ColumnLinks}.${AccessType.Write}`,
    ],
  ],
  [
    FeatureName.OverallAliasesWrite,
    [
      `${DataServices.Investigator}.${InvestigatorServiceActions.Aliases}.${AccessType.Write}`,
    ],
  ],
  [
    FeatureName.OverallRiskRead,
    [
      `${DataServices.Investigator}.${InvestigatorServiceActions.Stats}.${AccessType.Read}`,
    ],
  ],
  [
    FeatureName.OverallUniqueUsers,
    [
      `${DataServices.Investigator}.${InvestigatorServiceActions.UniqueUsers}.${AccessType.Read}`,
    ],
  ],
  [
    FeatureName.OverallColumns,
    [
      `${DataServices.Investigator}.${InvestigatorServiceActions.Columns}.${AccessType.Read}`,
    ],
  ],
  [
    FeatureName.OverallLayoutWrite,
    [
      `${DataServices.Investigator}.${InvestigatorServiceActions.Layouts}.${AccessType.Write}`,
    ],
  ],
  [
    FeatureName.OverallQueriesWrite,
    [
      `${DataServices.Investigator}.${InvestigatorServiceActions.Queries}.${AccessType.Write}`,
    ],
  ],
  // Organizations
  [
    FeatureName.OrganizationWrite,
    [
      `${DataServices.Organizations}.${OrganizationServiceActions.Organizations}.${AccessType.Write}`,
    ],
  ],
  [
    FeatureName.ApiKeysRead,
    [
      `${DataServices.ApiKeys}.${ApiKeysServiceActions.ApiKeys}.${AccessType.Read}`,
    ],
  ],
  [
    FeatureName.ApiKeysWrite,
    [
      `${DataServices.ApiKeys}.${ApiKeysServiceActions.ApiKeys}.${AccessType.Write}`,
    ],
  ],
  // Policies
  [
    FeatureName.PoliciesWrite,
    [
      `${DataServices.Policies}.${PoliciesServiceActions.Policies}.${AccessType.Write}`,
    ],
  ],
  [
    FeatureName.PoliciesSignalsRead,
    [
      `${DataServices.Policies}.${PoliciesServiceActions.Signals}.${AccessType.Read}`,
    ],
  ],
  [
    FeatureName.PoliciesSignalsWrite,
    [
      `${DataServices.Policies}.${PoliciesServiceActions.Signals}.${AccessType.Write}`,
    ],
  ],
  [
    FeatureName.PolicyListWrite,
    [
      `${DataServices.Policies}.${PoliciesServiceActions.Lists}.${AccessType.Write}`,
    ],
  ],
  [
    FeatureName.PolicyTriggersWrite,
    [
      `${DataServices.Policies}.${PoliciesServiceActions.Triggers}.${AccessType.Write}`,
    ],
  ],
  [
    FeatureName.PolicyTriggersRead,
    [
      `${DataServices.Policies}.${PoliciesServiceActions.Triggers}.${AccessType.Read}`,
    ],
  ],
  [
    FeatureName.PolicyVariableWrite,
    [
      `${DataServices.Policies}.${PoliciesServiceActions.Variables}.${AccessType.Write}`,
    ],
  ],
  [
    FeatureName.PolicyVariableRead,
    [
      `${DataServices.Policies}.${PoliciesServiceActions.Variables}.${AccessType.Read}`,
    ],
  ],
  [
    FeatureName.PolicyImport,
    [
      `${DataServices.Policies}.${PoliciesServiceActions.Import}.${AccessType.Write}`,
    ],
  ],
  [
    FeatureName.PolicyExport,
    [
      `${DataServices.Policies}.${PoliciesServiceActions.Export}.${AccessType.Read}`,
    ],
  ],
  // Switch organization
  [
    FeatureName.OrganizationSwitch,
    [
      `${DataServices.Access}.${AccessServiceActions.Switch}.${AccessType.Read}`,
      `${DataServices.Access}.${AccessServiceActions.Switch}.${AccessType.Write}`,
    ],
  ],
  // OTP Init data
  [
    FeatureName.OtpInitData,
    [
      `${DataServices.Access}.${AccessServiceActions.Otp}.${AccessType.Read}`,
    ],
  ],
]);
